import { TFunction } from 'react-i18next';
import { SequenceReportAccessesQuery, SurveyGroupWithoutRespondentsQuery, SurveyStatus } from '../../generated/hooks';
import { getTopicGroupName } from '../../lib/helpers';
import { SequenceStepsData } from './types';
import { AnsweredSpan, MetricsInfo, TopicDetailLink } from './utils';

export const getDataSource = (
  surveyGroup: NonNullable<SurveyGroupWithoutRespondentsQuery['surveyGroup']>,
  steps: NonNullable<SequenceReportAccessesQuery['surveyGroup']>['steps'],
  language: string,
  t: TFunction,
  isOnboarding?: boolean,
): SequenceStepsData[] =>
  steps.map((step, index) => ({
    id: step.processStep.stepTopicGroup.name,
    topic: getTopicGroupName(language, step.processStep.stepTopicGroup),
    metrics: <MetricsInfo step={step} />,
    daysFromStart: t('processDetail:dayText', {
      dayNo: step.daysFromStart,
    }),
    startOffset: step.processStep.startOffsetMins,
    reminderOffset: step.processStep.reminders?.[0]?.reminderOffsetMins,
    secondReminderOffset: step.processStep.reminders?.[1]?.reminderOffsetMins,
    thirdReminderOffset: step.processStep.reminders?.[2]?.reminderOffsetMins,
    endOffset: step.processStep.endOffsetMins,
    answered: <AnsweredSpan answered={step.statistics!.answered ?? 0} total={step.statistics!.total} />,
    detail:
      surveyGroup.topLevelReport?.accessKey &&
      surveyGroup.steps.some(
        (s) =>
          s.processStep.stepTopicGroup.id === step.processStep.stepTopicGroup.id &&
          // Report where are no surveys or only surveys that were not sent yet can't be opened
          s.surveys.some((s) => ![SurveyStatus.Prepared, SurveyStatus.Notstarted].includes(s.status)),
      ) ? (
        <TopicDetailLink
          accessToken={surveyGroup.topLevelReport?.accessKey ?? ''}
          topicGroupId={step.processStep.stepTopicGroup.id}
          label={t('onboarding:detail')}
        />
      ) : (
        <></>
      ),
  }));
